export default __webpack_public_path__ + "static/media/team-placeholder.66942209.svg";